// extracted by mini-css-extract-plugin
export default {"logo":"X6Gf3l17ThQOQvVX8rb6","logoStacked":"Gn7Qj6l58SUv9xJybckh","logoStandard":"wqBUIeZ_yoZLpupXjc2Z"};